// extracted by mini-css-extract-plugin
module.exports = {"message":"AsideMessage_message__kJVqu","myMessage":"AsideMessage_myMessage__ccati","lv":"AsideMessage_lv__2OqyT"};